//import logo from './logo.svg';
import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import NavBar from "./components/NavBar.jsx";
import Hero from "./blocks/Hero.jsx";
import Services from "./blocks/Services.jsx";
import WhyUs from "./blocks/WhyUs.jsx";
import Reasons from "./blocks/Reasons.jsx";
import ConsultationForm from "./components/ConsultationForm.jsx";
import ContactForm from "./components/ContactForm.jsx";
import Footer from "./components/Footer.jsx";
import ThankYou from "./components/ThankYou.jsx";

function App() {
  return (
  <BrowserRouter>
    <div className="App">
    <NavBar />
    <main>
      <Routes>
       <Route
         path="/"
         element={
          <>
            <Hero />
            <Services />
            <WhyUs />
            <Reasons />
            <ConsultationForm />
            <ContactForm />
          </>
         }
        />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </main>
    <Footer />
    </div>
  </BrowserRouter>
  );
}

export default App;
